export const FEATURES = {
  mapview: "mapview",
  dashboard: "dashboard",
  users: "users",
  construction: "construction",
};

export const ROLE_FEATURES = {
  admin: [
    FEATURES.mapview,
    FEATURES.dashboard,
    FEATURES.users,
    FEATURES.construction,
  ],
  editor: [FEATURES.mapview, FEATURES.dashboard, FEATURES.construction],
  viewer: [FEATURES.mapview, FEATURES.dashboard],
};

export const ROUTE_PERMISSIONS = {
  "/mapview": ["admin", "editor", "viewer"],
  "/dashboard": ["admin", "editor", "viewer"],
  "/users": ["admin"],
  "/construction": ["admin", "editor"],
};

function normalizeRole(role) {
  return typeof role === "string" ? role.toLowerCase() : "";
}

export function normalizeRoutePath(path) {
  if (!path) return path;
  const trimmed = path.replace(/\/+$/, "");
  return trimmed || "/";
}

export function canAccessFeature(role, feature) {
  const normalizedRole = normalizeRole(role);
  const allowed = ROLE_FEATURES[normalizedRole];
  return allowed ? allowed.includes(feature) : false;
}

export function canAccessRoute(role, path) {
  const normalizedRole = normalizeRole(role);
  const routeKey = normalizeRoutePath(path);
  const allowedRoles = ROUTE_PERMISSIONS[routeKey];
  return allowedRoles ? allowedRoles.includes(normalizedRole) : false;
}

export function getHeaderNavItems(role) {
  const items = [
    { label: "Dashboard", path: "/dashboard", feature: FEATURES.dashboard },
    { label: "Mapview", path: "/mapview", feature: FEATURES.mapview },
    { label: "Construction", path: "/construction", feature: FEATURES.construction },
    { label: "Users", path: "/users", feature: FEATURES.users },
  ];
  return items.filter((item) => canAccessFeature(role, item.feature));
}
